export interface SubscriberValidationDto
{
    getMsisdn(): string;
    getLanguage():string;
}

export class SubscriberValidationDtoImpl implements SubscriberValidationDto
{
    private msisdn: string;
    private language: string;

    getMsisdn(): string 
    {
        return this.msisdn;
    }
    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }

    getLanguage(): string 
    {
        return this.language;
    }
    setLanguage(language: string)
    {
        this.language = language;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/subscribervalidation/subscribervalidationdto.tsx